module.exports = __webpack_public_path__ + "static/img/40.9b4d2c24.png";